/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_PricingInputs */

const en_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const es_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const fr_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarifs`)
};

const de_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const ja_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金`)
};

const zh_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价`)
};

const ar_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسعار`)
};

const id_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const it_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

const ru_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тарифы`)
};

const pt_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços`)
};

const ko_footer_link_pricing = /** @type {(inputs: Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요금제`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Footer_Link_PricingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_pricing = /** @type {((inputs?: Footer_Link_PricingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_PricingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_pricing(inputs)
	if (locale === "es") return es_footer_link_pricing(inputs)
	if (locale === "fr") return fr_footer_link_pricing(inputs)
	if (locale === "de") return de_footer_link_pricing(inputs)
	if (locale === "ja") return ja_footer_link_pricing(inputs)
	if (locale === "zh") return zh_footer_link_pricing(inputs)
	if (locale === "ar") return ar_footer_link_pricing(inputs)
	if (locale === "id") return id_footer_link_pricing(inputs)
	if (locale === "it") return it_footer_link_pricing(inputs)
	if (locale === "ru") return ru_footer_link_pricing(inputs)
	if (locale === "pt") return pt_footer_link_pricing(inputs)
	return ko_footer_link_pricing(inputs)
});